import { render } from "./RaceResultsSliderItem.vue?vue&type=template&id=fa47bede&scoped=true"
import script from "./RaceResultsSliderItem.vue?vue&type=script&lang=js"
export * from "./RaceResultsSliderItem.vue?vue&type=script&lang=js"

import "./RaceResultsSliderItem.vue?vue&type=style&index=0&id=fa47bede&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa47bede"]])

export default __exports__